import AdditionalQuotationAmounts from '../domain/AdditionalQuotationAmounts';

export default async function getAdditionalQuotationAmounts(
  repository,
  reviewQuotationPayload,
) {
  const quotations = await repository.reviewQuotation(reviewQuotationPayload);

  return new AdditionalQuotationAmounts().fromQuotations(quotations);
}
